import Swal from 'sweetalert2'
import Dropzone from 'dropzone'

import { carouselItemHtml } from './carouselItemHtml'
import { sweetAlertCommonParams } from '../../functions/utils'
import { lang } from '../../assets/lang'

export const carouselSingleModal = async (oldData, node) => {
  const commonParams = sweetAlertCommonParams(node)
  
  return await Swal.fire({
    ...commonParams,
    title: lang.carousel_item_modal_title,
    html: carouselItemHtml,
    willOpen: () => {
      const fileUploadMediaUrlElement = $('#file-upload-media-url')
      fileUploadMediaUrlElement.val(oldData.file || '')

      let serverGeneratedFilename = ''
      Dropzone.autoDiscover = false
      window.flowBuilderUploadedFileData = {}
      var base_url = window.xitFlowBuilderData.base_url

      // eslint-disable-next-line
      const uploadCarouselItemDropzone = new Dropzone("#file-upload-dropzone", {
        url: base_url+'visual_flow_builder/flow_builder_upload_media',
        maxFilesize: 20,
        uploadMultiple: false,
        paramName: "media_file",
        createImageThumbnails: true,
        acceptedFiles: ".png, .jpg, .jpeg, .gif, .JPEG, .JPG, .PNG, .GIF",
        maxFiles: 1,
        addRemoveLinks: true,

        // eslint-disable-next-line
        success: async function(file, response) {
          // Display message if error
          if (false === response.status) {
            await Swal.fire({
              icon: 'error',
              text: response.message,
              title: lang.common.info.error + '!',
            });

            return
          }

          if (response.status) {
            serverGeneratedFilename = response.file

            window.flowBuilderUploadedFileData = {
              file: response.file,
            }

            fileUploadMediaUrlElement.val(response.file)
          }
        },

        // eslint-disable-next-line
        removedfile: function(file) {
          const fileData = window.flowBuilderUploadedFileData
          if (fileData.file && (fileData.file === serverGeneratedFilename)) {
            // eslint-disable-next-line
            const result = deleteUploadedFile(serverGeneratedFilename)
              .then(response => {
                if (response.status) {
                  window.flowBuilderUploadedFileData = {}
                  fileUploadMediaUrlElement.val('')
                  $('#file-upload-dropzone .dz-preview').remove()
                  Dropzone.forElement('#file-upload-dropzone').removeAllFiles(true)
                }
              }).catch(error => {
                if (error.status !== '200' && error.statusText) {
                  const message = error.status + ' ' + error.statusText
                  alert(message)
                } else {
                  console.log(error)
                }
              })
            
          }
        },
      })

      const deleteUploadedFile = async (file) => {
        return await $.ajax({
          type: 'POST',
          url: base_url+'visual_flow_builder/flow_builder_delete_media',
          dataType: 'JSON',
          data: { file }, 
        })
      }

      // Removes previous files if there is any
      Dropzone.forElement('#file-upload-dropzone').removeAllFiles(true)

      $('#carousel-item-image-link').val(oldData.imageClickDestinationLink || '')
      $('#carousel-item-title').val(oldData.carouselItemTitle || '')
      $('#carousel-item-subtitle').val(oldData.carouselItemSubtitle || '')
    },

    preConfirm: () => {
      const fileData = window.flowBuilderUploadedFileData
      const uploadedUrl = $('#file-upload-media-url').val()

      if ((0 === Object.values(fileData).length) && node.data.file) {
        fileData.file = node.data.file
      }
      
      if (uploadedUrl) {
        fileData.file = uploadedUrl
      }

      const imageClickDestinationLink = $('#carousel-item-image-link').val()
      const carouselItemTitle = $('#carousel-item-title').val()
      const carouselItemSubtitle = $('#carousel-item-subtitle').val()
      
      if (! carouselItemTitle) {
        Swal.showValidationMessage(lang.carousel_item_modal_msg_title)
      }
    
      return {
        carouselItemTitle,
        carouselItemSubtitle,
        imageClickDestinationLink,
        ...fileData,
      }
    },    
  })
}